import AccessLogTab from './AccessLogTab';
import DeliveryEntranceTab from './DeliveryEntranceTab';
import { TRACKING_TABS, TRACKING_VIEW } from '../Model/Models';
import CustomTabContainer from '../../../../components/CustomTabContainer';
import CustomTab from '../../../../components/CustomTab';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import { MATERIAL_TYPE } from '../EquipmentAndMaterial/Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Tracking = (props) => {
    const {
        subView,
        handleSubViewChange,
        t,
        moduleId,
        criteria,
        setCriteria,
        search,
        option,
        materialId,
        markAsCompleted,
        onHide,
        setShowMarkAsReadModal,
        setDisplayModal,
        equipment,
    } = props;
    const tabs =
        equipment?.equipmentOwner === MATERIAL_TYPE.CONTRACTOR_OWNER.name
            ? TRACKING_TABS.filter((t) => t.key !== TRACKING_VIEW.DELIVERY_ENTRANCE)
            : TRACKING_TABS;

    return (
        <div className='row col-12'>
            <div className='px-0 d-flex justify-content-between align-items-center'>
                <CustomTabContainer
                    activeTab={subView}
                    setActiveTab={handleSubViewChange}
                    className='rounded-top border-0 px-3'
                >
                    {tabs.map((item) => (
                        <CustomTab
                            key={item.key}
                            id={item.key}
                            title={t(item.translation)}
                            isSelected={subView === item.key}
                            label={t(item.translation)}
                            icon={item.icon}
                            selected={subView === item.key}
                            onClick={() => handleSubViewChange(item.key)}
                        />
                    ))}
                </CustomTabContainer>

                {subView === TRACKING_VIEW.ACCESS_LOG && (
                    <ExportDataBtn
                        classes='btn-outlined-secondary-600-00 btn-icon-svg btn-icon-svg-general'
                        id='btn_t_export'
                        moduleId={moduleId}
                        body={criteria}
                        search={search}
                        option={option}
                        setDisplayModal={setDisplayModal}
                    />
                )}
            </div>
            <div className='ml-2 mr-3'>
                <div className={'border-bottom-shades-300 mt-1 mb-3'} />
            </div>
            {subView === TRACKING_VIEW.ACCESS_LOG && (
                <AccessLogTab
                    t={t}
                    moduleId={moduleId}
                    setCriteria={setCriteria}
                    search={search}
                    option={option}
                    materialId={materialId}
                />
            )}
            {subView === TRACKING_VIEW.DELIVERY_ENTRANCE && (
                <DeliveryEntranceTab
                    materialId={materialId}
                    t={t}
                    markAsCompleted={markAsCompleted}
                    onHide={onHide}
                    setShowMarkAsReadModal={setShowMarkAsReadModal}
                    setDisplayModal={setDisplayModal}
                />
            )}
        </div>
    );
};

export default Tracking;
